/**
 * Rótulos de fallback dos perfis do seed inicial.
 *
 * **A fonte de verdade agora é a API** (`useRoleLabels`): perfis são dados e o
 * Administrador cria novos sem deploy, então um mapa estático não consegue
 * cobri-los. O que sobra aqui serve para render síncrono antes de a query
 * responder e para os slugs legados de `custodians.type`.
 */
export type UserRole =
  | 'admin'
  | 'finance'
  | 'governance'
  | 'manager'
  | 'collaborator'
  | 'rh'
  | 'supplier'
  | 'prestador_pj'
  | 'purchasing'
  | 'it'
  | 'audit';

export const ROLE_LABELS: Record<UserRole, string> = {
  admin: 'Administrador',
  finance: 'Financeiro',
  governance: 'Governança',
  manager: 'Gestor',
  collaborator: 'Colaborador',
  rh: 'RH',
  supplier: 'Fornecedor',
  prestador_pj: 'Prestador PJ',
  purchasing: 'Compras',
  it: 'TI',
  audit: 'Auditoria',
};

export const ROLE_OPTIONS: Array<{ value: UserRole; label: string }> = (
  Object.keys(ROLE_LABELS) as UserRole[]
)
  .map((value) => ({ value, label: ROLE_LABELS[value] }))
  .sort((a, b) => a.label.localeCompare(b.label, 'pt-BR'));

/**
 * Slugs que não são perfis de usuário:
 * - `department` e `client` são entidades não pessoais válidas desde a #541
 *   (Departamento = área organizacional, Cliente = cadastro mestre);
 * - `project` e os demais só aparecem em registros legados.
 */
const LEGACY_TYPE_LABELS: Record<string, string> = {
  employee_clt: 'Colaborador CLT',
  contractor_pj: 'Prestador PJ',
  department: 'Departamento',
  project: 'Projeto',
  client: 'Cliente',
};

/**
 * Devolve o rótulo amigável para qualquer valor de `custodian.type` — seja
 * um perfil, uma entidade não pessoal ou um slug legado. Cai no próprio
 * valor se não achar.
 */
export function labelForCustodianType(type: string): string {
  return ROLE_LABELS[type as UserRole] ?? LEGACY_TYPE_LABELS[type] ?? type;
}
